<template>
  <v-container id="regular-tables" fluid tag="section" style="font-size:10px">
    <base-material-card color="#ed3325" icon="mdi-clipboard-text" title="Mi empresa" class="px-5 py-3">
      <v-card elevation="0">
        <v-card-text>
          <h3>{{nombreEmpresa}}</h3>
          <p>RFC: {{ rfc }}     PROVEEDOR:{{ proveedor_id }}</p>
        </v-card-text>
      </v-card>
      <v-row v-if="tiene_docs">
        <v-col cols="12" md="4">
          <v-btn dense outlined color="primary" @click="openModalSubirArchivo()">Subir documentos</v-btn>
        </v-col>
      </v-row>
      <v-data-table :headers="headers" :items="documentos">
        <template v-slot:[`item.update`]="{ item }">
          <v-btn class="mx-2" color="blue" small @click="updateDoc(item)" fab title="Actualizar documento"><v-icon dark>mdi-refresh</v-icon></v-btn>
          <v-btn class="mx-2" color="green" small @click="verDoc(item)" fab title="Ver documento" v-if="item.nombre !== ''"><v-icon dark>mdi-eye</v-icon></v-btn>
        </template>
      </v-data-table>
    </base-material-card>

    <v-dialog v-model="dialogPDF" fullscreen hide-overlay transition="dialog-bottom-transition" :loading="true">
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialogPDF = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Visualizador PDF</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="savePDF()">
                <v-icon>mdi-content-save</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
           <iframe :src="urlPDF" title="Cotizacion" :height="height" width="100%" type="application/pdf" />
        </v-card>
      </v-dialog>

       <v-dialog transition="dialog-bottom-transition" max-width="600" v-model="dialogUpdate" >
          <v-card>
              <v-toolbar color="primary" dark>ACTUALIZAR {{origenUpdate}}</v-toolbar>
              <v-card-text>
                <v-file-input label="Seleccionar archivo" filled prepend-icon="mdi-file" v-model="documento"></v-file-input>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn text @click="dialogUpdate = false">Close</v-btn>
                <v-btn @click="subirArchivo()" color="primary">Actualizar</v-btn>
              </v-card-actions>
            </v-card>
        </v-dialog>

      <v-dialog transition="dialog-bottom-transition" max-width="1200" v-model="dialogSubir">
            <v-card>
              <v-toolbar color="primary" dark>Subir Archivo</v-toolbar>
              <v-card-text>
                <v-row>
                    <v-col md="6">
                      <v-file-input accept="application/pdf" label="ACTA CONSTITUTIVA" v-model="actaConst"></v-file-input>
                    </v-col>
                    <v-col md="6">
                      <v-file-input accept="application/pdf" label="INE DEL REPRESENTANTE LEGAL" v-model="ineRep"></v-file-input>
                    </v-col>
                    <v-col md="6">
                        <v-file-input accept="application/pdf" label="PODER NOTARIAL" v-model="poderNota"></v-file-input>
                    </v-col>
                    <v-col md="6">
                        <v-file-input accept="application/pdf" label="CARTA DE OPINION DE CUMPLIMIENTO" v-model="cartaOpinion"></v-file-input>
                    </v-col>
                    <v-col md="6">
                        <v-file-input accept="application/pdf" label="COMPROBANTE DE DOMICILIO" v-model="compDomicilio"></v-file-input>
                    </v-col>
                    <v-col md="6">
                        <v-file-input accept="application/pdf" label="CONSTANCIA DE SITUACION FISCAL" v-model="constSituacionFiscal"></v-file-input>
                    </v-col>
                    <v-col md="6">
                        <v-file-input accept="application/pdf" label="CARATULA BANCARIA" v-model="caratulaBanc"></v-file-input>
                    </v-col>
                    <v-col md="6">
                        <v-file-input accept="application/pdf" label="CONTRATOS" v-model="contratos"></v-file-input>
                    </v-col>
                  </v-row>
                  <v-snackbar
                    v-model="snackbar"
                  >
                    {{ mensajeSnack }}

                    <template v-slot:action="{ attrs }">
                      <v-btn
                        color="pink"
                        text
                        v-bind="attrs"
                        @click="snackbar = false"
                      >
                        Close
                      </v-btn>
                    </template>
                  </v-snackbar>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn text @click="dialogSubir = false">Cerrar</v-btn>
                <v-btn color="primary" @click="subirArchivoLegal()">Subir archivos</v-btn>
              </v-card-actions>
            </v-card>
        </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import swal from 'vue-sweetalert2'
export default {
  data() {
    return {
      headers: [
        { text: '#', value: 'id' },
        { text: 'Nombre', value: 'nombre' },
        { text: 'Fecha Modificacion', value: 'fecha' },
        { text: 'Origen', value: 'origenName' },
        { text: 'Actualizar', value: 'update' }
      ],
      documentos: [],
      nombreEmpresa: '',
      rfc: '',
      proveedor_id: '',
      dialogPDF: false,
      urlPDF: '',
      height: window.innerHeight - 70,
      dialogUpdate: false,
      origenUpdate: '',
      documentoSelected: '',
      documento: '',
      tiene_docs: false,
      dialogSubir: false,
      loadingRegistro:false,
      //docs
      actaConst: [],
      ineRep: [],
      poderNota: [],
      cartaOpinion: [],
      compDomicilio: [],
      constSituacionFiscal: [],
      caratulaBanc: [],
      contratos: [],
      alert: false,
      mensajeAlert: '',
      snackbar: false,
      mensajeSnack:''
    }
  },
  created() {
    this.nombreEmpresa = localStorage.getItem('nombre')
    this.rfc = localStorage.getItem('rfc')
    this.proveedor_id = localStorage.getItem('proveedor_id')
    this.getDocsEmpresa()
    this.height = window.innerHeight - 70
  },
  methods: {
    async getDocsEmpresa() {
      const id_p = localStorage.getItem('proveedor_id') ? localStorage.getItem('proveedor_id') : 0
      await axios.get('/proveedores/getDocumentosLegales/'+id_p).then(resp => {
        const { data } = resp
        if (data.data.length > 0) {
          this.tiene_docs = false
        } else {
          this.tiene_docs = true
        }
        data.data.forEach(element => {
          element.fecha = this.format_date(element.updated_at)
          if (element.origen === 'ACT') {
            element.origenName = 'ACTA CONSTITUTIVA'
          }
          if (element.origen === 'INE') {
            element.origenName = 'INE DEL REPRESENTANTE'
          }
          if (element.origen === 'POD') {
            element.origenName = 'PODER NOTARIAL'
          }
          if (element.origen === 'CAR') {
            element.origenName = 'CARTA DE OPINION DE CUMPLIMIENTO'
          }
          if (element.origen === 'CSF') {
            element.origenName = 'CONSTANCIA DE SITUACION FISCAL'
          }
          if (element.origen === 'CPB') {
            element.origenName = 'COMPROBANTE DE DOMICILIO'
          }
          if (element.origen === 'BAN') {
            element.origenName = 'CARATULA BANCARIA'
          }
          if (element.origen === 'CRT') {
            element.origenName = 'CONTRATOS'
          }
        });
        this.documentos = data.data
      })
    },
    updateDoc(item) {
      this.dialogUpdate = true
      this.origenUpdate = item.origenName
      this.documentoSelected = item
    },
    verDoc(item) {
      this.documento = ''
      this.dialogPDF = true
      this.urlPDF = ''
      this.urlPDF = 'data:application/pdf;base64,' + item.base_64
    },
    savePDF() {

    },
    async subirArchivo() {
      try {
        const formData = new FormData()
        formData.append('file', this.documento)
        formData.append('id_doc', this.documentoSelected.id);
        formData.append('proveedor_id', this.documentoSelected.id_proveedor);
        formData.append('origen', this.documentoSelected.origen);
        await axios.post('/proveedores/documentoUpdate', formData).then(resp => {
          this.dialogUpdate = false
          this.getDocsEmpresa()
          this.$swal('Mensaje', resp.data.mensaje)
        })
      } catch (e) {
        this.$swal('Mensaje', 'Error de conexion')
      }
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format('YYYY/MM/DD')
      }
    },
    openModalSubirArchivo() {
      this.dialogSubir = true
    },
    showSnackBar(mensaje) {
      this.snackbar = true
      this.mensajeSnack = mensaje
    },
    async subirArchivoLegal() {

      if (this.actaConst === undefined || this.actaConst.length === 0) {

        this.showSnackBar('Debe agregar el ACTA CONSTITUTIVA')
        return
      }
      if (this.ineRep === undefined || this.ineRep.length === 0) {
        this.showSnackBar('Debe agregar el Ine del representante legal')
        return
      }
      if (this.cartaOpinion === undefined || this.cartaOpinion.length === 0) {
        this.showSnackBar('Debe agregar la carta de opinion de cumplimiento')
        return
      }
      if (this.compDomicilio === undefined || this.compDomicilio.length === 0) {
        this.showSnackBar('Debe agregar el comprobante de domicilio')
        return
      }
      if (this.constSituacionFiscal === undefined || this.constSituacionFiscal.length === 0) {
        this.showSnackBar('Debe agregar la constancia de situacion fiscal')
        return
      }
      if (this.caratulaBanc === undefined || this.caratulaBanc.length === 0) {
        this.showSnackBar('Debe agregar la caratula bancaria')
        return
      }

      this.alert = false

      var formData = new FormData();
      const proveedor_id = localStorage.getItem('proveedor_id')
      const id = localStorage.getItem('id')
      formData.append('actaConstitutiva', this.actaConst);
      formData.append('ine', this.ineRep);
      formData.append('poderN', this.poderNota);
      formData.append('carta', this.cartaOpinion);
      formData.append('comprobante', this.compDomicilio);
      formData.append('constSituacion', this.constSituacionFiscal);
      formData.append('caraBancaria', this.caratulaBanc);
      formData.append('contratos', this.contratos);
      formData.append('id_usuario', id);
      formData.append('proveedor_id', proveedor_id)

      try {
        await axios.post('/proveedores/docs', formData).then(resp => {
          const json = resp
          if (json.data.success) {
            this.dialogSubir = false
            this.getDocsEmpresa()
          } else {
            this.dialogSubir = false
            this.showAlert(data.mensaje)
          }
        })
      } catch (e) {

      }

     }
  },
}
</script>
